export default "__VITE_ASSET__CwGPIRVc__"